export const SET_FILTERS = "dashboard/SET_FILTERS";
export const RESET_FILTERS = "dashboard/RESET_FILTERS";

export const setFilters = (filters) => ({ type: SET_FILTERS, payload: { filters } });
export const resetFilters = () => ({ type: RESET_FILTERS });

// Backward compatibility aliases for old code
export const cleanFiltersRequest = resetFilters;
export const setFiltersDashboard = setFilters;
